import React from 'react';
import { Modal } from 'react-bootstrap';
import PropTypes from 'prop-types';

const ModalPreviewItem = props => {
  const { handleModalClose, showModal } = props;

  return (
    <React.Fragment>
      <Modal
        size="lg"
        show={showModal}
        onHide={handleModalClose}
        animation={true}
      >
        <Modal.Body>
          <props.component />
          <div className="container-fluid">
            <button
              type="button"
              className="btn btn-secondary float-right"
              onClick={handleModalClose}
            >
              <i className="fa fa-times"></i>
              &nbsp;Fechar
            </button>
          </div>
        </Modal.Body>
      </Modal>
    </React.Fragment>
  );
};

ModalPreviewItem.propTypes = {
  handleModalClose: PropTypes.func,
  showModal: PropTypes.bool,
  component: PropTypes.func
};

export default ModalPreviewItem;
